import React, { Component } from 'react';

import { Client } from './style/Client';
import api from '../../../../services/api';

export default class Edit extends Component {
	formEditClient = {
		id: '',
		customerName: {
			value: '',
		},
		documentNumber: {
			value: '',
		},
		webmotorsId: {
			value: '',
		},
		facebookAdsCode: {
			value: '',
		},
		instagramCode: {
			value: '',
		},
		googleAdsCode: {
			value: '',
		},
		wazeCode: {
			value: '',
		},
	};

	state = {
		...this.formEditClient,
	};

	componentDidMount() {
		const { match } = this.props;

		api.get(`/customers/${match.params.clientId}`)
			.then((response) => {
				const dataClient = {
					id: response.data.data.id,
					customerName: {
						value: response.data.data.attributes.company_name,
					},
					documentNumber: {
						value: response.data.data.attributes.document_number,
					},
					webmotorsId: {
						value: response.data.data.attributes.webmotors_id,
					},
					facebookAdsCode: {
						value: response.data.data.attributes.facebook_ads_code,
					},
					instagramCode: {
						value: response.data.data.attributes.instagram_code,
					},
					googleAdsCode: {
						value: response.data.data.attributes.google_ads_code,
					},
					wazeCode: {
						value: response.data.data.attributes.waze_code,
					},
				};

				this.setState(dataClient);
			});
	}

	onChange = (e) => {
		const state = {
			...this.state,
			[e.target.name]: {
				...this[e.target.name],
				value: e.target.value,
			},
		};

		return this.setState(state);
	};

	updateDataClient = () => {
		const { match, history } = this.props;

		const {
			facebookAdsCode, instagramCode, googleAdsCode, wazeCode,
		} = this.state;

		const data = {
			facebook_ads_code: facebookAdsCode.value,
			instagram_code: instagramCode.value,
			google_ads_code: googleAdsCode.value,
			waze_code: wazeCode.value,
		};

		api.put(`/customers/${match.params.clientId}`, JSON.stringify(data))
			.then(() => history.push('/backoffice/clientes', { clientEdited: true }));
	};

	render() {
		const {
			customerName,
			documentNumber,
			webmotorsId,
			facebookAdsCode,
			instagramCode,
			googleAdsCode,
			wazeCode,
		} = this.state;

		return (
			<Client>
				<div className="page-container">
					<article className="position-relative" id="home-page">
						<div className="content-welcome p-0">
							<h2>Dados do cliente</h2>

							<div className="table-list">
								<h2 className="mb-4 p-0 title-form">Editar dados</h2>

								<div className="form-group">
									<h3 className="mb-2"><label htmlFor="customerName">Nome</label></h3>
									<input
										type="text"
										id="customerName"
										name="customerName"
										className="form-control input-txt"
										value={customerName.value}
										onChange={this.onChange}
										readOnly
									/>
								</div>

								<div className="form-group">
									<h3 className="mb-2"><label htmlFor="documentNumber">CNPJ</label></h3>
									<input
										type="text"
										id="documentNumber"
										name="documentNumber"
										className="form-control input-txt"
										value={documentNumber.value}
										onChange={this.onChange}
										readOnly
									/>
								</div>

								<div className="form-group">
									<h3 className="mb-2"><label htmlFor="webmotorsId">Código Webmotors</label></h3>
									<input
										type="text"
										id="webmotorsId"
										name="webmotorsId"
										className="form-control input-txt"
										value={webmotorsId.value}
										onChange={this.onChange}
										readOnly
									/>
								</div>

								<div className="form-group">
									<h3 className="mb-2"><label htmlFor="facebookAdsCode">Código Facebook Ads</label></h3>
									<input
										type="text"
										id="facebookAdsCode"
										name="facebookAdsCode"
										className="form-control input-txt"
										value={facebookAdsCode.value}
										onChange={this.onChange}
									/>
								</div>

								<div className="form-group">
									<h3 className="mb-2"><label htmlFor="instagramCode">Código Instagram</label></h3>
									<input
										type="text"
										id="instagramCode"
										name="instagramCode"
										className="form-control input-txt"
										value={instagramCode.value}
										onChange={this.onChange}
									/>
								</div>

								<div className="form-group">
									<h3 className="mb-2"><label htmlFor="googleAdsCode">Código Google Ads</label></h3>
									<input
										type="text"
										id="googleAdsCode"
										name="googleAdsCode"
										className="form-control input-txt"
										value={googleAdsCode.value}
										onChange={this.onChange}
									/>
								</div>

								<div className="form-group">
									<h3><label htmlFor="wazeCode">Código Waze</label></h3>
									<input
										type="text"
										id="wazeCode"
										name="wazeCode"
										className="form-control input-txt"
										value={wazeCode.value}
										onChange={this.onChange}
									/>
								</div>
							</div>

							<div className="container-button">
								<button type="button" className="btn btn-secondary w-100 py-2 mb-3" onClick={this.updateDataClient}>Atualizar cliente</button>
							</div>
						</div>
					</article>
				</div>
			</Client>
		);
	}
}
